/**
 * im聊天公用服务
 * 2019-7-15
 * Bai.Zhiming
 */
angular.module('imServiceModule', ['imShowBigImageModule', 'onGroupSystemNotifysModule']).factory('imService', [
    '$filter',
    '$rootScope',
    '$templateRequest',
    '$compile',
    '$controller',
    'ueditorService',
    '$q',
    'modalDialog',
    'trsHttpService',
    '$timeout',
    function($filter, $rootScope, $templateRequest, $compile, $controller, ueditorService, $q, modalDialog, trsHttpService, $timeout) {
        let times = 0,
            audioTimer;
        /**
         * [playChatTips description] 聊天提示音
         * @return {[type]} [description]
         */
        function playChatTips() {
            let noSound = localStorage.getItem('imNoSound') == 'true' ? true : false;
            if (noSound) return;
            if (audioTimer) {
                clearTimeout(audioTimer);
                audioTimer = null;
            }
            audioTimer = setTimeout(() => {
                let $audio = $(document.createElement('audio'));
                $audio.attr({
                    src: './images/chatTips.mp3',
                });
                $audio[0].play();
            }, 800);
        }
        /**
         * [setCommonMsg description] 发送普通信息
         * @param {[type]} imService            [description]
         * @param {[type]} content            [description]
         * @param {[type]} selType            [description]
         * @param {[type]} subType            [description]
         * @param {[type]} toAccound          [description]
         * @param {[type]} headurl            [description]
         * @param {[type]} loginName          [description]
         * @param {[type]} loginNickName      [description]
         * @param {[type]} sendMessageSuccess [description]
         */
        function setCommonMsg(
            imService,
            content,
            selType,
            subType,
            toAccound,
            headurl,
            loginName,
            loginNickName,
            sendMessageSuccess,
            sendMessageFailed
        ) {
            content = ueditorService.getTextContent(content);
            let deffer = $q.defer();
            let isSend = true; //是否为自己发送
            let seq = -1; //消息序列，-1表示sdk自动生成，用于去重
            let random = Math.round(Math.random() * 4294967296);
            let msgTime = Math.round(imService.getExactTime() / 1000); //消息时间戳
            let selSess = new webim.Session(selType, toAccound, toAccound, headurl, msgTime);
            let msg = new webim.Msg(selSess, isSend, seq, random, msgTime, loginName, subType, loginNickName);
            let textObj = new webim.Msg.Elem.Text(content);
            msg.addText(textObj);
            msg.PushInfo = {
                PushFlag: 0,
                Desc: '测试离线推送内容', //离线推送内容
                Ext: '测试离线推送透传内容', //离线推送透传内容
                AndroidInfo: {
                    Sound: 'android.mp3', //离线推送声音文件路径。
                },
                ApnsInfo: {
                    Sound: 'apns.mp3', //离线推送声音文件路径。
                    BadgeMode: 1,
                },
            };
            msg.PushInfoBoolean = true; //是否开启离线推送push同步
            msg.sending = 1;
            msg.originContent = textObj;
            webim.sendMsg(
                msg,
                (resp) => {
                    if (angular.isFunction(sendMessageSuccess)) sendMessageSuccess(resp, msg);
                },
                (error) => {
                    if (error.ErrorCode == 10007) {
                        modalDialog.alertType('您已被管理员移出该群组,无法发言', '', 'warning', 'confirm');
                    }
                    if (angular.isFunction(sendMessageFailed)) sendMessageFailed(error, msg);
                }
            );
        }
        /**
         * [setHtmlMsg description] 发送HTML消息
         * @param {[type]} content            [description]
         * @param {[type]} selType            [description]
         * @param {[type]} subType            [description]
         * @param {[type]} toAccound          [description]
         * @param {[type]} headurl            [description]
         * @param {[type]} loginName          [description]
         * @param {[type]} loginNickName      [description]
         * @param {[type]} sendMessageSuccess [description]
         */
        function setHtmlMsg(
            imService,
            content,
            selType,
            subType,
            toAccound,
            headurl,
            loginName,
            loginNickName,
            sendMessageSuccess,
            sendMessageFailed
        ) {
            let deffer = $q.defer();
            let $div = $('<div></div>');
            $div.html(content);
            $div.find('*').removeAttr('style');
            let data = $div.html();
            let desc = ueditorService.getTextContent(content);
            let htmlContent = $div.html();
            let isSend = true; //是否为自己发送
            let seq = -1; //消息序列，-1表示sdk自动生成，用于去重
            let random = Math.round(Math.random() * 4294967296);
            let msgTime = Math.round(imService.getExactTime() / 1000); //消息时间戳
            let selSess = new webim.Session(selType, toAccound, toAccound, headurl, msgTime);
            let msg = new webim.Msg(selSess, isSend, seq, random, msgTime, loginName, subType, loginNickName);
            let custom_obj = new webim.Msg.Elem.Custom(data, desc);
            msg.addCustom(custom_obj);
            webim.sendMsg(
                msg,
                (resp) => {
                    if (angular.isFunction(sendMessageSuccess)) sendMessageSuccess(resp, msg);
                },
                (error) => {
                    if (error.ErrorCode == 10007) {
                        modalDialog.alertType('您已被管理员移出该群组,无法发言', '', 'warning', 'confirm');
                    }
                    if (angular.isFunction(sendMessageFailed)) sendMessageFailed(resp, msg);
                }
            );
        }
        /**
         * [getImHeadUrl description] 获取聊天头像
         * @param  {[type]} accountId   [description] 账号id
         * @param  {[type]} accountType [description] 类型 1为C2C 2为group
         * @return {[type]}             [description]
         */
        $rootScope.getImHeadUrl = function(accountId, accountType) {
            let info = $rootScope.imInfoMap[accountId];
            if (info) {
                return info.image;
            } else {
                return accountType == 1 ? './images/chart_default_head.png' : './images/group_chart_default.png';
            }
        };
        return {
            /**
             * [sdkAppID description] 聊天应用id
             * @type {Number}
             */
            sdkAppID: '',
            admyinUserSig: '',
            /**
             * [getSdkAppId description] 获取sdkAppId
             * @return {[type]} [description]
             */
            getSdkAppId() {
                let deffer = $q.defer();
                if (this.sdkAppID) {
                    deffer.resolve(this.sdkAppID);
                    return deffer.promise;
                }
                let params = {
                    serviceid: 'mlf_im',
                    methodname: 'getSkdAppId',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    (resp) => {
                        this.sdkAppID = resp.DETAIL;
                        deffer.resolve(this.sdkAppID);
                    },
                    (error) => {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            },
            /**
             * [getUserSign description] 获取用户的im签名
             * @param  {[type]} userName [description] 用户名
             * @return {[type]}          [description]
             */
            getUserSign(userName) {
                let deffer = $q.defer();
                let params = {
                    serviceid: 'mlf_im',
                    methodname: 'getUserSig',
                    userName: userName,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    (resp) => {
                        deffer.resolve(resp.DETAIL);
                    },
                    (error) => {
                        deffer.reject(error);
                    }
                );
                return deffer.promise;
            },
            /**
             * [getAdminUserSign description] 获取管理员签名
             * @return {[type]} [description]
             */
            getAdminUserSign() {
                let deffer = $q.defer();
                if (this.admyinUserSig) {
                    deffer.resolve(this.admyinUserSig);
                    return deffer.promise;
                }
                this.getUserSign('tmyadmin').then(
                    (resp) => {
                        this.admyinUserSig = resp;
                        deffer.resolve(this.admyinUserSig);
                    },
                    (error) => {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            },
            /**
             * [dateFormat description] 日期格式化
             * @param  {[type]} time [description] 日期数据
             * @return {[type]}      [description]
             */
            dateFormat(time) {
                let today = $filter('date')(new Date(), 'yyyy-MM-dd');
                let theDay = $filter('date')(new Date(time * 1e3), 'yyyy-MM-dd');
                return today == theDay ? $filter('date')(new Date(time * 1e3), 'HH:mm') : $filter('date')(new Date(time * 1e3), 'MM-dd');
            },
            /**
             * [dateFormat2 description] 日期格式化2
             * @param  {[type]} time [description] 日期数据
             * @return {[type]}      [description]
             */
            dateFormat2(time) {
                let today = $filter('date')(new Date(), 'yyyy-MM-dd');
                let theDay = $filter('date')(new Date(time * 1e3), 'yyyy-MM-dd');
                return today == theDay
                    ? $filter('date')(new Date(time * 1e3), 'HH:mm:ss')
                    : $filter('date')(new Date(time * 1e3), 'yyyy/MM/dd HH:mm:ss');
            },
            /**
             * [dateFormat3 description] 日期格式化3
             * @param  {[type]} time [description] 日期数据
             * @return {[type]}      [description]
             */
            dateFormat3(time) {
                let today = $filter('date')(new Date(), 'yyyy-MM-dd');
                let theDay = $filter('date')(new Date(time * 1e3), 'yyyy-MM-dd');
                return today == theDay ? $filter('date')(new Date(time * 1e3), 'HH:mm') : $filter('date')(new Date(time * 1e3), 'yyyy/MM/dd HH:mm');
            },
            /**
             * [login description] 用户登录
             * @param  {[type]} userName  [description] 用户名称
             * @param  {[type]} nickName  [description] 用户昵称
             * @param  {[type]} headurl   [description] 用户头像
             * @param  {[type]} userSig   [description] 用户签名
             * @param  {[type]} listeners [description] 用户登录成功后的监听事件
             * @return {[type]}           [description]
             */
            login(userName, nickName, headurl, userSig, listeners) {
                let deffer = $q.defer();
                if (times >= 3) {
                    deffer.reject();
                    return deffer.promise;
                }
                this.getSdkAppId().then((sdkAppID) => {
                    let loginInfo = {
                        headurl: headurl,
                        identifier: userName,
                        identifierNick: nickName,
                        sdkAppID: sdkAppID,
                        userSig: userSig,
                    };
                    let options = {
                        isAccessFormalEnv: true,
                        isLogOn: true,
                    };
                    webim.login(
                        loginInfo,
                        listeners,
                        options,
                        (resp) => {
                            if (headurl != resp.headurl) {
                                //更换头像
                                this.logonIm(userName, nickName, headurl, userSig, listeners).then(
                                    () => {
                                        deffer.resolve();
                                    },
                                    () => {
                                        deffer.resolve();
                                    }
                                );
                            } else {
                                deffer.resolve();
                            }
                        },
                        (err) => {
                            if (err.ErrorCode == 70013) {
                                //用户名与签名不匹配
                                times++;
                                this.logonIm(userName, nickName, headurl, userSig).then(() => {
                                    console.log(`3秒钟后尝试下一次登录，剩余${3 - times}次机会`);
                                    setTimeout(() => {
                                        //注册成功以后3秒再登录一遍
                                        this.login(userName, nickName, headurl, userSig, listeners).then(
                                            (resp) => {
                                                deffer.resolve();
                                            },
                                            (err) => {
                                                deffer.reject();
                                            }
                                        );
                                    }, 3e3);
                                });
                            } else if (err.ErrorCode == 70009) {
                                console.log('公钥校验不匹配');
                                deffer.reject();
                            }
                            //modalDialog.alertType(err.ErrorCode, err.SrcErrorInfo, "error", 'confirm');
                            //deffer.reject();
                        }
                    );
                });
                return deffer.promise;
            },
            /**
             * [logonIm description] 如果发现该用户没有腾讯云账号，注册一个
             * @param  {[type]} userName [description] 用户名
             * @param  {[type]} nickName [description] 昵称
             * @param  {[type]} faceUrl  [description] 头像
             * @return {[type]}          [description]
             */
            logonIm(userName, nickName, faceUrl) {
                let deffer = $q.defer();
                this.getSdkAppId()
                    .then((sdkAppID) => {
                        return this.getAdminUserSign();
                    })
                    .then((tmyadminUserSign) => {
                        let url = `https://console.tim.qq.com/v4/im_open_login_svc/account_import?usersig=${tmyadminUserSign}&apn=1&identifier=tmyadmin&sdkappid=${
                            this.sdkAppID
                        }&contenttype=json&random=${Math.round(Math.random() * 1e10)}`;
                        $.ajax({
                            type: 'POST',
                            url: url,
                            contentType: 'text/plain;charset=UTF-8',
                            dataType: 'json',
                            data: JSON.stringify({
                                Identifier: userName,
                                Nick: nickName,
                                FaceUrl: faceUrl,
                                Type: 0,
                            }),
                            success(result) {
                                if (result.ActionStatus == 'OK') {
                                    deffer.resolve();
                                } else {
                                    modalDialog.alertType(result.ErrorInfo, result.ErrorCode, 'error', false);
                                    deffer.reject();
                                }
                            },
                            error(result) {
                                modalDialog.alertType('注册聊天账号失败', '', 'error', false);
                                deffer.reject();
                            },
                        });
                    });
                return deffer.promise;
            },
            /**
             * [getGroupInfo description] 获取群信息
             * @param  {[type]} groupId [description] 群id
             * @return {[type]}         [description]
             */
            getGroupInfo(groupId) {
                let deffer = $q.defer();
                let options = {
                    GroupIdList: [groupId],
                    GroupBaseInfoFilter: [
                        'Type',
                        'Name',
                        'Introduction',
                        'Notification',
                        'FaceUrl',
                        'CreateTime',
                        'Owner_Account',
                        'LastInfoTime',
                        'LastMsgTime',
                        'NextMsgSeq',
                        'MemberNum',
                        'MaxMemberNum',
                        'ApplyJoinOption',
                        'ShutUpAllMember',
                    ],
                    MemberInfoFilter: ['Account', 'Role', 'JoinTime', 'LastSendMsgTime', 'ShutUpUntil'],
                };
                webim.getGroupInfo(
                    options,
                    (resp) => {
                        deffer.resolve(resp.GroupInfo);
                    },
                    (error) => {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            },
            /**
             * [getGroupHistory description] 获取群组历史记录
             * @param  {[type]} groupId      [description] 群组id
             * @param  {[type]} Seq          [description] 查询起始点
             * @param  {[type]} ReqMsgNumber [description] 查询数目
             * @return {[type]}              [description]
             */
            getGroupHistory(groupId, ReqMsgNumber, Seq) {
                let deffer = $q.defer();
                webim.MsgStore.delSessByTypeId('GROUP', groupId); //如果不加这一句，第二次查找不到群历史记录
                $timeout(() => {
                    let options = {
                        GroupId: groupId,
                        ReqMsgNumber: ReqMsgNumber,
                        ReqMsgSeq: Seq,
                    };
                    webim.syncGroupMsgs(
                        options,
                        (resp) => {
                            /*let nickName = resp[0].fromAccountNick;
                    let text = scope.item.LastMsg.MsgBody[0].MsgContent.Text;*/
                            //$timeout(() => {
                            deffer.resolve(resp);
                            /*let TextProcessed = `${nickName}:${text}`;
                    scope.item.LastMsg.MsgBody[0].MsgContent.TextProcessed = TextProcessed;*/
                            //});
                        },
                        (error) => {
                            console.log(error);
                            console.log('获取群组历史消息失败');
                            deffer.reject();
                        }
                    );
                }, 800);
                return deffer.promise;
            },
            /**
             * [playChatTips description] 播放聊天提示音
             * @return {[type]} [description]
             */
            playChatTips() {
                playChatTips();
            },
            /**
             * [sendHtmlMsg description] 发送富文本信息
             * @param  {[type]} content      [description] 正文信息
             * @return {[type]} [description]
             */
            sendMsg(content, selType, subType, toAccound, headurl, loginName, loginNickName, sendMessageSuccess, sendMessageFailed) {
                let $div = $('<div></div>');
                $div.html(content);
                let flag = false;
                if ($div.find('img,iframe,video,audio,a').length > 0) {
                    flag = true;
                } else if ($div.find('iframe').length > 0) {
                    flag = true;
                }
                if (flag) {
                    setHtmlMsg(this, content, selType, subType, toAccound, headurl, loginName, loginNickName, sendMessageSuccess, sendMessageFailed);
                } else {
                    setCommonMsg(
                        this,
                        content,
                        selType,
                        subType,
                        toAccound,
                        headurl,
                        loginName,
                        loginNickName,
                        sendMessageSuccess,
                        sendMessageFailed
                    );
                }
            },
            /**
             * [getGroupList description] 获取群组列表
             * @param  {[type]} loginUser  [description] 群组成员明
             * @param  {Number} totalCount [description] 获取群组数量上限
             * @return {[type]}            [description]
             */
            getGroupList(loginUser, totalCount = 200) {
                let deffer = $q.defer();
                let options = {
                    Member_Account: loginUser,
                    Limit: totalCount,
                    Offset: 0,
                    //'GroupType':'',
                    GroupBaseInfoFilter: [
                        'Type',
                        'Name',
                        'Introduction',
                        'Notification',
                        'FaceUrl',
                        'CreateTime',
                        'Owner_Account',
                        'LastInfoTime',
                        'LastMsgTime',
                        'NextMsgSeq',
                        'MemberNum',
                        'MaxMemberNum',
                        'ApplyJoinOption',
                        'ShutUpAllMember',
                    ],
                    SelfInfoFilter: ['Role', 'JoinTime', 'MsgFlag', 'UnreadMsgNum'],
                };
                webim.getJoinedGroupListHigh(
                    options,
                    (resp) => {
                        deffer.resolve(resp.GroupIdList);
                    },
                    (error) => {
                        deffer.reject(error);
                    }
                );
                return deffer.promise;
            },
            /**
             * [getGroupMember description] 获取群组成员
             * @param  {[type]} groupId [description] 群组id
             * @param  {[type]} maxLimit [description] 获取成员上限
             * @return {[type]}         [description]
             */
            getGroupMember(groupId, maxLimit = 200) {
                let deffer = $q.defer();
                var options = {
                    GroupId: groupId,
                    Offset: 0, //必须从0开始
                    Limit: maxLimit,
                    MemberInfoFilter: [
                        'Account',
                        'Role',
                        'JoinTime',
                        'LastSendMsgTime',
                        'ShutUpUntil',
                        'NameCard', //群名片
                    ],
                };
                webim.getGroupMemberInfo(
                    options,
                    (resp) => {
                        deffer.resolve(resp.MemberList);
                    },
                    (error) => {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            },
            /**
             * [initShowBigImage description] 初始化查看大图
             * @param  {[type]} $element [description] 查看大图区域dom
             * @param  {[type]} scope    [description] 区域节点scope
             * @return {[type]}          [description]
             */
            initShowBigImage($element, scope) {
                let prviateScope;
                getTemplate().then((template) => {
                    compileTemplate(template);
                });
                $element.delegate('.message_area img,.chart_editor img', 'dblclick', (e) => {
                    let $target = $(e.target);
                    if ($target.hasClass('emotion')) return;
                    $timeout(() => {
                        let srcArray = $target.attr('src').split('#'),
                            src;
                        if (srcArray.length >= 2) {
                            src = srcArray[1];
                        } else {
                            src = srcArray[0];
                        }
                        showImagePosition(src).then((position) => {
                            prviateScope.status.showBigImage = true;
                            prviateScope.data.imgSrc = src;
                            prviateScope.data.imgPosition = position;
                        });
                    });
                });
                /**
                 * [showImagePosition description] 计算图片位置
                 * @return {[type]} [description]
                 */
                function showImagePosition(imgSrc) {
                    let deffer = $q.defer();
                    let img = new Image();
                    img.src = imgSrc;
                    let winWidth = window.innerWidth;
                    let winHeight = window.innerHeight;
                    img.onload = function() {
                        let width = img.width;
                        let height = img.height;
                        if (width < winWidth && height < winHeight) {
                            deffer.resolve({
                                width: width + 'px',
                                height: height + 'px',
                                left: winWidth / 2 - width / 2 + 'px',
                                top: winHeight / 2 - height / 2 + 'px',
                            });
                        } else {
                            let winAspectRatio = winWidth / winHeight;
                            let aspectRatio = width / height;
                            if (winAspectRatio > aspectRatio) {
                                deffer.resolve({
                                    height: winHeight + 'px',
                                    top: '0px',
                                    left: winWidth / 2 - (winHeight * aspectRatio) / 2 + 'px',
                                });
                            } else {
                                deffer.resolve({
                                    width: winWidth + 'px',
                                    left: '0px',
                                    top: winHeight / 2 - winWidth / aspectRatio / 2 + 'px',
                                });
                            }
                        }
                    };
                    img.onerror = function() {
                        modalDialog.alertType('该图片地址无效', '', 'warning', 'confirm');
                        deffer.reject();
                    };
                    return deffer.promise;
                }
                /**
                 * [getTemplate description] 获取模板
                 * @return {[type]} [description]
                 */
                function getTemplate() {
                    let deffer = $q.defer();
                    $templateRequest('./IM/service/showBigImage/showBigImage_tpl.html').then((template) => {
                        deffer.resolve(template);
                    });
                    return deffer.promise;
                }
                /**
                 * [compileTemplate description] 编译模板
                 * @param  {[type]} template [description] 模板字符串
                 * @param  {[object]} noticeInfo [description] 提醒内容
                 * @return {[type]}          [description]
                 */
                function compileTemplate(template) {
                    let $template = $(template);
                    var controller = {};
                    prviateScope = scope.$new();
                    prviateScope.status = {
                        showBigImage: false,
                    };
                    prviateScope.data = {};
                    controller.$scope = prviateScope;
                    controller.$element = $template;
                    $template = $compile($template)(controller.$scope);
                    $('body').append($template);
                    $controller('imShowBigImageCtrl', controller);
                }
            },
            /**
             * [deleteGroupMember description] 删除群成员
             * @param  {[type]} groupId       [description] 群组id
             * @param  {[type]} memberAccounts [description] 成员账号集合
             * @return {[type]}               [description]
             */
            deleteGroupMember(groupId, memberAccounts) {
                let deffer = $q.defer();
                let options = {
                    GroupId: groupId,
                    MemberToDel_Account: memberAccounts,
                };
                webim.deleteGroupMember(
                    options,
                    function(resp) {
                        deffer.resolve(resp);
                    },
                    function(err) {
                        deffer.reject(err);
                    }
                );
                return deffer.promise;
            },
            /**
             * [destroyGroup description] 解散群组
             * @param  {[type]} groupId [description] 群组id
             * @return {[type]}         [description]
             */
            destroyGroup(groupId) {
                let deffer = $q.defer();
                let options = {
                    GroupId: groupId,
                };
                webim.destroyGroup(
                    options,
                    function(resp) {
                        deffer.resolve(resp);
                    },
                    function(err) {
                        deffer.reject(resp);
                    }
                );
                return deffer.promise;
            },
            /**
             * [quitGroup description] 退群
             * @param  {[type]} groupId [description] 群组id
             * @return {[type]}         [description]
             */
            quitGroup(groupId) {
                let deffer = $q.defer();
                let options = {
                    GroupId: groupId,
                };
                webim.quitGroup(
                    options,
                    function(resp) {
                        deffer.resolve(resp);
                    },
                    function(err) {
                        deffer.reject(err);
                    }
                );
                return deffer.promise;
            },
            /**
             * [addGroupMember description] 邀请成员加群
             * @param  {[type]} groupId       [description] 群组id
             * @param  {[type]} memberAccounts [description] 成员账号集合
             * @return {[type]}               [description]
             */
            addGroupMember(groupId, memberAccounts) {
                let deffer = $q.defer();
                memberAccounts = memberAccounts.map((item) => {
                    return {
                        Member_Account: item,
                    };
                });
                let options = {
                    GroupId: groupId,
                    MemberList: memberAccounts,
                };
                webim.addGroupMember(
                    options,
                    (resp) => {
                        deffer.resolve(resp);
                    },
                    (err) => {
                        deffer.reject(err);
                    }
                );
                return deffer.promise;
            },
            /**
             * [modifyGroupBaseInfo description] 修改群资料
             * @param  {[type]} options [description] 修改信息
             * @return {[type]}         [description]
             */
            modifyGroupBaseInfo(options) {
                let deffer = $q.defer();
                webim.modifyGroupBaseInfo(
                    options,
                    (resp) => {
                        deffer.resolve(resp);
                    },
                    (err) => {
                        deffer.reject(err);
                    }
                );
                return deffer.promise;
            },
            /**
             * [getServerTime description] 获取服务端时间
             * @return {[type]} [description]
             */
            getServerTime() {
                let deffer = $q.defer();
                //deffer.resolve(new Date());
                let params = {
                    serviceid: 'mlf_im',
                    methodname: 'getCurrentTime',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', true).then(
                    (resp) => {
                        if (angular.isObject(resp) && resp.ISSUCCESS == 'true') {
                            deffer.resolve(new Date(Number(resp.DETAIL)));
                        } else {
                            deffer.resolve(new Date());
                        }
                    },
                    () => {
                        deffer.resolve(new Date());
                    }
                );
                return deffer.promise;
            },
            /**
             * [calibrationTime description] 获取时间差
             * @return {[type]} [description]
             */
            calibrationTime() {
                this.getServerTime().then((serverTime) => {
                    let clientTime = new Date();
                    this.timeDifference = serverTime - clientTime;
                });
            },
            /**
             * [getExactTime description] 获取准确当前时间，排除了客户端时间的误差
             * @return {[type]} [description]
             */
            getExactTime() {
                return new Date().getTime() + this.timeDifference;
            },
            /**
             * [applyAddFriend description] 申请加为好友
             * @param  {[type]} friendAccount [description] 好友账号
             * @param  {[type]} myAccount [description] 我的账号
             * @return {[type]}         [description]
             */
            applyAddFriend(friendAccount, myAccount) {
                let deffer = $q.defer();
                let options = {
                    AddFriendItem: [
                        {
                            AddSource: 'AddSource_Type_Unknow',
                            AddWording: '你好，我想和你成为朋友~~',
                            To_Account: friendAccount,
                        },
                    ],
                    From_Account: myAccount,
                };
                webim.applyAddFriend(
                    options,
                    (resp) => {
                        deffer.resolve();
                        $timeout(() => {
                            this.getAllFriend(myAccount);
                        }, 400);
                    },
                    (error) => {
                        deffer.resolve();
                    }
                );
                return deffer.promise;
            },
            /**
             * [initRootScopeInfoMap description] 获取群组和好友信息的infomap,主要解决头像不同步的坑
             * @param  {[type]} myInfo [description] 我的信息
             * @return {[type]} [description]
             */
            initRootScopeInfoMap(myInfo) {
                let deffer = $q.defer();
                $rootScope.imInfoMap = {};
                let myAccount = `${myInfo.TENANTID}_${myInfo.USERNAME}`;
                $rootScope.imInfoMap[myAccount] = {
                    nickName: myInfo.TRUENAME,
                    image: myInfo.USERHEAD ? myInfo.USERHEAD : './images/chart_default_head.png',
                };
                $rootScope.imInfoMap['@TIM#SYSTEM'] = {
                    nickName: '系统消息',
                    image: './images/im_system.png',
                };
                $q.all([this.getAllFriend(myAccount), this.getJoinedGroupListHigh(myAccount)]).then(() => {
                    deffer.resolve();
                });
                return deffer.promise;
            },
            /**
             * [getAllFriend description]
             * @param  {[type]} myAccount [description] 我的账号
             * @return {[type]} [description]
             */
            getAllFriend(myAccount) {
                let deffer = $q.defer();
                let options = {
                    From_Account: myAccount,
                    TimeStamp: 0,
                    StartIndex: 0,
                    GetCount: 200,
                    LastStandardSequence: 0,
                    TagList: ['Tag_Profile_IM_Nick', 'Tag_Profile_IM_Image'],
                };
                webim.getAllFriend(
                    options,
                    (resp) => {
                        let firends = resp.InfoItem instanceof Array ? resp.InfoItem : [];
                        firends.forEach((item) => {
                            $rootScope.imInfoMap[item.Info_Account] = {
                                nickName: item.SnsProfileItem[0].Value,
                                image:
                                    angular.isObject(item.SnsProfileItem[1]) && item.SnsProfileItem[1].Value
                                        ? item.SnsProfileItem[1].Value
                                        : './images/chart_default_head.png',
                            };
                        });
                        deffer.resolve(resp);
                    },
                    (error) => {
                        deffer.resolve(error);
                    }
                );
                return deffer.promise;
            },
            /**
             * [getJoinedGroupListHigh description] 获取加入的所有群组的信息
             * @param  {[type]} myAccount [description] 我的账号
             * @return {[type]} [description]
             */
            getJoinedGroupListHigh(myAccount) {
                let deffer = $q.defer();
                let options = {
                    Member_Account: myAccount,
                    Limit: 200,
                    Offset: 0,
                    GroupBaseInfoFilter: ['Name', 'FaceUrl'],
                };
                webim.getJoinedGroupListHigh(
                    options,
                    (resp) => {
                        let groupList = angular.isArray(resp.GroupIdList) ? resp.GroupIdList : [];
                        groupList.forEach((item) => {
                            $rootScope.imInfoMap[item.GroupId] = {
                                nickName: item.Name,
                                image: item.FaceUrl ? item.FaceUrl : './images/group_chart_default.png',
                            };
                        });
                        deffer.resolve(resp);
                    },
                    (error) => {
                        deffer.resolve();
                    }
                );
            },
        };
    },
]);
